/** Run bounded model work between browser tasks so input and painting can proceed. */
export async function runCooperatively<T>(steps: Generator<void, T>): Promise<T> {
  let started = performance.now();
  while (true) {
    const result = steps.next();
    if (result.done) return result.value;
    if (performance.now() - started >= 8) {
      await new Promise<void>((resolve) => setTimeout(resolve, 0));
      started = performance.now();
    }
  }
}
